module.exports = __webpack_public_path__ + "6c8ecbaac0e2bb822776d84059021778.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/EC.svg
// module id = pPnz
// module chunks = 0